var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"steps-box"},[_c('div',{staticClass:"steps-second-item"},[(_vm.props.num)?_c('div',{staticClass:"item-title"},[_c('span',[_vm._v(_vm._s(_vm.props.num))]),_vm._v(_vm._s(_vm.props.content))]):_vm._e(),_c('img',{attrs:{"src":_vm.props.href}})])])}
var staticRenderFns = []

export { render, staticRenderFns }